import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {UsuarioService} from "../../services/usuario.service";
import {MessageService} from "../../core/services/message.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../../services/login.service";
import {Perfil} from "../../models/perfil";
import {PerfilService} from "../../services/perfil.service";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {EstadoService} from "../../services/estado.service";
import {MunicipioService} from "../../services/municipio.service";
import {DialogUsuarioExternoComponent} from "../dialogs/dialog-usuario-externo/dialog-usuario-externo.component";
import {MatDialog, MatSelectChange} from "@angular/material";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
    selector: 'app-visualizar-cadastro-externo',
    templateUrl: './visualizar-cadastro-externo.component.html',
    styleUrls: ['./visualizar-cadastro-externo.component.scss']
})
export class VisualizarCadastroExternoComponent implements OnInit {

    public usuario: Usuario = new Usuario();
    public perfis: Array<Perfil> = [];
    public form: FormGroup;
    public estados: Array<Estado>;
    public municipio: Municipio = new Municipio();

    constructor(private usuarioService: UsuarioService,
                private perfilService: PerfilService,
                private loginService: LoginService,
                private estadoService: EstadoService,
                private messageService: MessageService,
                private loadingService: NgxSpinnerService,
                private municipioService: MunicipioService,
                private validator: ValidatorService,
                private dialog: MatDialog,
                private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
        let id = this.route.snapshot.params['id'];
        if (id) {
            this.carregarUsuario(id)
        }

    }

    carregarUsuario(cod_usuario: number): void {
        this.loadingService.show();
        this.usuarioService.findVisualizarExterno(cod_usuario).subscribe((usuario: Usuario) => {
            this.loadingService.hide();
            this.usuario = usuario;
            this.municipioService.findById(this.usuario.cod_municipio).subscribe((municipio: Municipio) => {
                this.municipio = municipio;
            });
        }, (error) => {
            this.loadingService.hide();
            this.messageService.showResponseError(error);
        });
    }

    downlaod(cod_usuario: number): void {
        this.usuarioService.solicitacaoDownloadExterno(cod_usuario);
    }
}
